import styled from 'styled-components';
import { Retry } from '@components/common';

export const TableWrapper = styled.div`
  width: auto;
  min-height: auto;
  flex: 1;
  margin: 10px 0;

  .BaseTable__body {
    .BaseTable__row:hover,
    .BaseTable__row--hovered {
      background-color: #fff;
    }
  }
`;

export const LoadingWrapper = styled(Retry)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ScopeWrapper = styled.span`
  width: 100%;
  padding-right: 7.5px;
`;

export const HoverDiv = styled.div`
  width: 100%;

  .handle {
    visibility: hidden;
  }

  &:hover .handle {
    visibility: visible;
  }
`;
